import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "alp_icon" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.type == 'svg')
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          style: _normalizeStyle(_ctx.calcIconStyle),
          innerHTML: _ctx.iconPath
        }, null, 12, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          style: _normalizeStyle(_ctx.calcIconStyle),
          src: _ctx.svgImg
        }, null, 12, _hoisted_3))
  ]))
}